import { Check, Clear, HorizontalRule, HourglassBottomTwoTone } from '@mui/icons-material';

export const BooleanIndicator = ({ value }: { value?: boolean | null | undefined }) => {
  if (value === undefined || value === null) {
    return <HorizontalRule color={'action'} />;
  }

  return value ? <Check color={'success'} /> : <Clear color={'error'} />;
};

export const WaitOrDoneIndicator = ({ value }: { value?: boolean | null | undefined }) => {
  if (value === undefined || value === null) {
    return <HorizontalRule color={'action'} />;
  }

  return value ? <Check color={'success'} /> : <HourglassBottomTwoTone color={'action'} />;
};
